import React, { useEffect, useRef, useState } from "react";
import * as Shared from "../components/CivicShared";
const { api, copy, subCategories, wardPath, VIJAYANAGAR_WARDS, CIVIC_CATEGORIES, CIVIC_CATEGORIES_KN, Gate, SectionHeading, CivicStat, MiniAction, InfoCard, SimplePage, LocationPickerMap, Modal, FeedbackBox, NotFound, AlertCircle, ArrowLeft, ArrowRight, Bell, BriefcaseBusiness, Building2, Check, CheckCircle2, ChevronDown, Clock3, Eye, EyeOff, FileText, Globe2, HeartHandshake, Home, Lightbulb, LockKeyhole, LogIn, LogOut, Mail, MapPin, Menu, MessageCircle, MessageSquare, Phone, Search, ShieldCheck, Smartphone, UserCircle, UserRound, Users, X, MapContainer, TileLayer, useMapEvents } = Shared;

function TrackComplaintPage({ user, setUser, t, onBack }) {
  return (
    <SimplePage title="Track Complaint" onBack={onBack}>
      <div className="standalone-action-wrap">
        <Modal type="track" user={user} setUser={setUser} close={onBack} t={t} standalone />
      </div>
    </SimplePage>
  );
}


export default TrackComplaintPage;
